import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import CoreModules from '../../component/executive/coreModules/CoreModules';
import { MdOutlineMap, MdOutlinePendingActions, MdOutlineCheckCircle, MdOutlineCancel } from 'react-icons/md';

const CORE_MODULE_IDS = [
  'livestock-population',
  'markets-trade',
  'infrastructure',
  'workforce-institutional',
  'planning-reporting',
  'conflicts-dispute',
];


const StatDot = ({ stat }) => {
  const Icon = stat.icon;
  return (
    <div className={`flex items-center gap-3 rounded-xl border px-4 py-3 ${stat.accent}`}>
      <Icon size={20} className={stat.text} />
      <div>
        <p className={`text-xl font-black leading-none ${stat.text}`}>{stat.value}</p>
        <p className="text-xs text-gray-500 mt-0.5">{stat.label}</p>
      </div>
    </div>
  );
};

const StateDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const currentYear    = new Date().getFullYear();
  const currentQuarter = `Q${Math.ceil((new Date().getMonth() + 1) / 3)}`;
  const userName  = user?.name || user?.username || 'State Officer';
  const stateName = user?.state || user?.stateName || 'State';

  return (
    <div className="p-6 bg-white rounded-md shadow-md min-h-screen">
      {/* Role banner */}
      <div className="rounded-2xl bg-gradient-to-r from-[#1a3a6b] via-[#1e4d9a] to-[#2563eb] px-6 py-5 text-white mb-2">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="text-[10px] font-bold uppercase tracking-widest text-blue-200 mb-1">
              State Operations Dashboard
            </p>
            <h1 className="text-xl font-black leading-tight">Welcome, {userName}</h1>
            <div className="mt-2 flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center rounded-full bg-white/15 border border-white/20 px-2.5 py-0.5 text-xs font-semibold">
                {stateName}
              </span>
              <span className="inline-flex items-center rounded-full bg-white/15 border border-white/20 px-2.5 py-0.5 text-xs font-semibold">
                {currentQuarter} · {currentYear}
              </span>
            </div>
          </div>
          <div className="flex flex-col items-end gap-2 shrink-0">
            <div className="text-right text-xs text-blue-200">
              <p className="font-semibold">State Data Officer · R04</p>
              <p className="mt-0.5 opacity-75">Click any module to validate records</p>
            </div>
            <button
              type="button"
              onClick={() => navigate('/geospatial-overview')}
              className="flex items-center gap-2 rounded-xl bg-white/15 border border-white/25 px-3 py-1.5 text-xs font-semibold text-white hover:bg-white/25 transition"
            >
              <MdOutlineMap size={14} />
              Geospatial View
            </button>
          </div>
        </div>
      </div>

 

      {/* Core module cards — 6 modules, state level */}
      <CoreModules filter={CORE_MODULE_IDS} title="Module Overview" />
    </div>
  );
};

export default StateDashboard;
